/**
 * Anniversary Popup Modal
 * Shows the anniv-modal section's markup after a delay, once per visitor
 * within the configured snooze window. Snooze state lives in localStorage
 * (survives across tabs/sessions) keyed by the section's own id, so
 * multiple instances (should that ever happen) don't collide.
 */
(function () {
  var STORAGE_PREFIX = 'juicyway:anniv-modal:dismissed-until:';

  function now() {
    return Date.now();
  }

  function getDismissedUntil(key) {
    try {
      var raw = window.localStorage.getItem(STORAGE_PREFIX + key);
      var n = raw ? parseInt(raw, 10) : 0;
      return isNaN(n) ? 0 : n;
    } catch (err) {
      return 0;
    }
  }

  function setDismissedUntil(key, days) {
    try {
      var until = now() + Math.max(0, days) * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(STORAGE_PREFIX + key, String(until));
    } catch (err) {
      /* localStorage unavailable (private mode, etc.) - popup will just
         show again next load, not a functional break. */
    }
  }

  function initModal(el) {
    var key = el.id;
    var delaySeconds = parseFloat(el.getAttribute('data-delay')) || 0;
    var snoozeDays = parseFloat(el.getAttribute('data-snooze-days')) || 0;

    if (getDismissedUntil(key) > now()) return;

    var timer = setTimeout(function () {
      el.hidden = false;
      var closeBtn = el.querySelector('.anniv-modal__close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }, delaySeconds * 1000);

    function dismiss() {
      clearTimeout(timer);
      el.hidden = true;
      setDismissedUntil(key, snoozeDays);
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') dismiss();
    }

    el.querySelectorAll('[data-anniv-dismiss]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        dismiss();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-anniv-modal]').forEach(initModal);
  });
})();
